import { render, staticRenderFns } from "./DocumentationBody.vue?vue&type=template&id=5de59958"
import script from "./DocumentationBody.vue?vue&type=script&lang=js"
export * from "./DocumentationBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports